<nav
  class="navbar-top sticky-top bg-primary border-bottom navbar navbar-expand navbar-dark"
  [ngClass]="isMenuToggled && 'menu-toggled'"
>
  <div class="px-0 container-fluid">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="align-items-center ml-md-0 navbar-nav" *ngIf="connectedUser">
        <li (click)="openSideNav()" id="toggle-side-bar" class="nav-item">
          <div
            class="sidenav-toggler sidenav-toggler-dark"
            [ngClass]="{
              active: !isMenuToggled
            }"
            #toggleIcon
          >
            <div class="custom-toggler-left sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a
            id="user-profile-dropdown"
            class="pr-0 nav-link"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <div class="align-items-center media">
              <span class="rounded-circle avatar avatar-sm">
                <img
                nz-tooltip
                [nzTooltipTitle]="'الملف الشخصي '"
                nzTooltipPlacement="bottom"
                  alt="Image placeholder"
                  [src]="
                    connectedUser?.type === USER_TYPES.CONTROLLER
                      ? 'assets/img/default-avatar.png'
                      : connectedUser?.avatar?.public_url
                      ? (isDemoMode ? '' : BLOB_URL) +
                        connectedUser?.avatar?.filename
                      : 'assets/img/default-avatar.png'
                  "
                  onerror="'../../assets/img/default-avatar.png'"
                />
              </span>
            </div>
          </a>
          <div class="dropdown-menu-left text-right dropdown-menu">
            <a class="dropdown-item" routerLink="/profile">
              <span class="mr-2">الملف الشخصي</span>
              <i class="ni ni-single-02"></i>
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/contact">
              <span class="mr-2">خدمة دعم العملاء</span>
              <i class="ni ni-settings-gear-65"></i>
            </a>
            <a
              *ngIf="
                connectedUser?.type == USER_TYPES.BUYER ||
                connectedUser?.type == USER_TYPES.SELLER ||
                connectedUser?.type == USER_TYPES.BUYER_SELLER
              "
              class="dropdown-item"
              routerLink="/rules"
            >
              <span class="mr-2">الشروط و الأحكام</span>
              <i class="ni ni-single-copy-04"></i>
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" (click)="logout()">
              <span class="mr-2">الخروج</span>
              <i class="ni ni-user-run"></i>
            </a>
          </div>
        </li>
      </ul>

      <ul class="align-items-center navbar-nav" *ngIf="connectedUser">
        <li class="nav-item dropdown">
          <a
            id="notifications-bell"
            class="nav-link"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            nz-tooltip
            [nzTooltipTitle]="'عرض الإشعارات'"
            nzTooltipPlacement="bottom"
          >
            <i class="ni ni-bell-55">
              <span class="badge badge-pill"
                ><strong> {{ (todos$ | async).allNotifCount }}</strong></span
              >
            </i>
          </a>
          <div
            class="dropdown-menu-left py-0 overflow-hidden dropdown-menu dropdown-menu-xl"
          >
            <!-- Dropdown header -->
            <div class="px-3 py-3 text-right">
              <h6 class="m-0 text-muted text-sm" *ngIf="notifNumber">
                لديك
                <strong class="text-primary">{{
                  (todos$ | async).allNotifCount
                }}</strong>
                إشعار (ات)
              </h6>
            </div>
            <!-- List group -->
            <div class="list-group list-group-flush">
              <app-list-notifications
                (notifNumber)="setNotifNumber($event)"
                [fromNavbar]="true"
              ></app-list-notifications>
            </div>
            <!-- View all -->
            <a
              [routerLink]="APP_ROUTES.PRIVATE.DASHBOARD.NOTIFICATIONS"
              class="py-3 font-weight-bold text-primary text-center dropdown-item"
              >عرض الكل</a
            >
          </div>
        </li>

        <li class="nav-item">
          <button
            *ngIf="
              connectedUser.type == USER_TYPES.BUYER_SELLER ||
              connectedUser?.type === USER_TYPES.SELLER
            "
            id="add-product-btn"
            class="m-1 btn btn-sm btn-white btn-add-product"
            [routerLink]="APP_ROUTES.PRIVATE.DASHBOARD.PRODUCT_CHILDS.ADD"
            nz-tooltip
            [nzTooltipTitle]="'إضافة منتج جديد'"
            nzTooltipPlacement="bottom"
          >
            إضافة عرض
          </button>

          <button
            *ngIf="
              connectedUser.type == USER_TYPES.BUYER_SELLER ||
              connectedUser?.type === USER_TYPES.SELLER ||
              connectedUser?.type === USER_TYPES.BUYER ||
              connectedUser?.type === USER_TYPES.TRANSPORTER_AGENT ||
              connectedUser?.type === USER_TYPES.TRANSPORTER_COMPANY
            "
            id="wallet-btn"
            class="m-1 btn btn-sm btn-white btn-add-product"
            [routerLink]="'/myaccount/wallet'"
            nz-tooltip
            [nzTooltipTitle]="'شحن رصيد المحفظة'"
            nzTooltipPlacement="bottom"
          >
            شحن رصيد
          </button>

          <button
            *ngIf="
              connectedUser.type === USER_TYPES.TRANSPORTER_AGENT ||
              connectedUser?.type === USER_TYPES.TRANSPORTER_COMPANY
            "
            id="add-transport-btn"
            class="btn btn-sm btn-white btn-add-product"
            [routerLink]="APP_ROUTES.PRIVATE.DASHBOARD.TRANSPORT_CHILDS.ADD_CAR"
            nz-tooltip
            [nzTooltipTitle]="'إضافة وسيلة نقل جديدة'"
            nzTooltipPlacement="bottom"
          >
            إضافة وسيلة نقل
          </button>
        </li>
      </ul>

      <ul
        #login
        class="float-right"
        *ngIf="
          !connectedUser && url != '/auth/login' && url != '/auth/register'
        "
      >
        <li class="nav-item">
          <button
            id="login-btn"
            class="btn btn-white btn-sm fs-14"
            routerLink="/auth/login"
            nz-tooltip
            [nzTooltipTitle]="'تسجيل الدخول إلى حسابك'"
            nzTooltipPlacement="bottom"
          >
            تسجيل الدخول
          </button>
        </li>
      </ul>
    </div>
    
    <!-- Desktop Logo (visible on medium screens and up) -->
    <a routerLink="/" href="javascript:;" class="d-md-block d-none">
      <span class="text-white site-title fs-22">
        <span class="main-font-en text-lowercase">Kharaaj</span> خراج
      </span>
    </a>
    
    <!-- Mobile Home Icon (visible on small screens only) -->
    <a routerLink="/" href="javascript:;" class="d-block ml-auto d-md-none">
      <i class="text-white ni ni-shop fs-22" 
         nz-tooltip
         [nzTooltipTitle]="' الرئيسية'"
         nzTooltipPlacement="bottom"></i>
    </a>
  </div>
</nav>